import React, { useEffect, useState } from 'react';
import {
  Box,
  GDSStyleObject,
  FormField,
  Select,
} from '@leagueplatform/genesis-core';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import COBQuestioner from '../../../../assets/json/COB_QUESTIONER.json';
import useCobStore from '../../../../store/cob-store';
import { AdditionalInfo } from '../../../../types/online-forms.types';
import { getAccessToken } from '../../../helpers/helpers';
import { cobLibrary } from '../../../../cob-library.config';
import { COBLayout } from '../../../cob-layout/cob-layout';

export function SameInsuranceAs(props: any) {
  const {
    nextButtonClicked,
    firstName,
    lastName,
    dateOfBirth,
    errorHandling,
    index,
    OPISResponseInfo,
    partnerToken,
  } = props;
  const config = cobLibrary.getConfig();
  const { HIGHMARK_API_URL, useCurrentRegionUbkHeader } = config;
  const currentUbk: any = useCurrentRegionUbkHeader() || null;
  const ubkValue = currentUbk?.headers?.Brandubk || null;
  const reteriveURL = `${HIGHMARK_API_URL}/digital/v2/members/coordination-of-benefits/form`;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dependantList = useCobStore((state: any) => state.demographics);
  const cobInformation = useCobStore((state: any) => state.cobInformation);
  const relationList: {
    key: string;
    value: any;
    label: string;
    dob: string;
  }[] = [];
  const fName = firstName[0];
  const lName = lastName[0];
  const dob = dateOfBirth[0];
  let itemsList = [];
  const retainselectedDetail = localStorage.getItem('memberCopyOf');
  const [form, setForm] = useState({
    selectedDependentInfo: '',
  });

  const [errors, setErrors] = useState({
    selectedDependentInfo: false,
  });

  useEffect(() => {
    if (nextButtonClicked) {
      errorHandling(true);
    } else {
      errorHandling(false);
    }
  }, [errorHandling, nextButtonClicked]);

  const checkIsAnyDependentOpted = cobInformation?.additionalInsurance.filter(
    (item: any) => item.hasAdditionalInsurance === 'Y',
  );

  const changeDateFormat = (demographicDOB: any) => {
    const date = new Date(demographicDOB); // Or your date here
    const utcDate = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds(),
      date.getUTCMilliseconds(),
    );
    return `${
      utcDate.getMonth() < 9
        ? `0${utcDate.getMonth() + 1}`
        : parseInt(utcDate.getMonth().toString(), 10) + 1
    }/${
      utcDate.getDate() < 10
        ? `0${utcDate.getDate()}`
        : parseInt(utcDate.getDate().toString(), 10)
    }/${date.getUTCFullYear()}`;
  };

  const relationshipList = () => {
    relationList.push({
      key: '',
      value: '',
      label: COBQuestioner.COB.QUESTIONS.CONTROLS.SAMEINSURANCEAS.NONE,
      dob: '',
    });

    checkIsAnyDependentOpted?.forEach((link: any, relationIndex: any) => {
      if (
        link.member.firstName !== fName ||
        link.member.lastName !== lName ||
        link.member.dateOfBirth !== dob
      ) {
        relationList.push({
          key: relationIndex.toString(),
          value: `${`${link.member.firstName}-DOB-${link.member.dateOfBirth}`}`,
          label: `${`${link.member.firstName} ${
            link.member.lastName
          } ${changeDateFormat(link.member.dateOfBirth)}`}`,
          dob: link.member.dateOfBirth,
        });
      }
    });
    return relationList;
  };

  const relationsList = relationshipList();
  const memberCopyOf: any = [];
  let ParsedJson: any = {};
  if (retainselectedDetail !== null) {
    ParsedJson = JSON.parse(retainselectedDetail)?.filter(
      (item: any) => item.index === index,
    );
  }
  const copyMemberInfo = (event: any) => {
    const { value, id } = event.target;
    const selectedDOB = value.split('-DOB-')[1];
    const selectedDependant = value.split('-DOB-')[0];
    const currentPageContent = OPISResponseInfo;
    const memberCopy = {
      memberInfo: '',
      firstName: fName,
      lastName: lName,
      dob,
      index,
      currentMember: `${OPISResponseInfo?.member?.firstName}`,
      OPISInfo: currentPageContent,
    };

    const selectedMemberContent = cobInformation?.additionalInsurance.filter(
      (memberDetail: AdditionalInfo) =>
        memberDetail.member.firstName === selectedDependant &&
        memberDetail.member.dateOfBirth === selectedDOB,
    );

    const currentMemberContent =
      event.target.value !== ''
        ? cobInformation?.additionalInsurance.filter(
            (memberDetail: AdditionalInfo) =>
              memberDetail.member.firstName === selectedDependant &&
              memberDetail.member.dateOfBirth === selectedDOB,
          )
        : cobInformation.additionalInsurance.filter(
            (memberDetail: AdditionalInfo) =>
              memberDetail.member.firstName === fName &&
              memberDetail.member.lastName === lName &&
              memberDetail.member.dateOfBirth === dob,
          );
    if (selectedMemberContent?.length > 0) {
      OPISResponseInfo.insuranceCarrier =
        selectedMemberContent[0].insuranceCarrier;
      OPISResponseInfo.groupNumber = selectedMemberContent[0].groupNumber;
      OPISResponseInfo.effectiveDate = selectedMemberContent[0].effectiveDate;
      OPISResponseInfo.cancelDate = selectedMemberContent[0].cancelDate;
      OPISResponseInfo.policyNumber = selectedMemberContent[0].policyNumber;
      OPISResponseInfo.relationshipToSubscriber =
        selectedMemberContent[0].relationshipToSubscriber;
      OPISResponseInfo.employmentStatus =
        selectedMemberContent[0].employmentStatus;
      OPISResponseInfo.retirementDate = selectedMemberContent[0].retirementDate;
      OPISResponseInfo.hasAdditionalInsurance =
        selectedMemberContent[0].hasAdditionalInsurance;
      OPISResponseInfo.subscriber.member.firstName =
        selectedMemberContent[0].subscriber.member.firstName;
      OPISResponseInfo.subscriber.member.lastName =
        selectedMemberContent[0].subscriber.member.lastName;
      OPISResponseInfo.subscriber.member.dateOfBirth =
        selectedMemberContent[0].subscriber.member.dateOfBirth;
      OPISResponseInfo.custody = '';
      OPISResponseInfo.parentWithPrimaryMedicalResponsibility = '';
      OPISResponseInfo.dependentInformationCourtOrder = '';
    } else {
      setIsLoading(true);
      getAccessToken(reteriveURL, partnerToken, ubkValue).then(
        (result: any) => {
          const errData = result?.errMsg;
          if (!errData) {
            setIsLoading(false);
            if (result) {
              const additionalInsuranceDetails =
                // result?.additionalInsurance[index];
                result?.additionalInsurance.filter(
                  (memberDetail: AdditionalInfo) =>
                    memberDetail.member.firstName === fName &&
                    memberDetail.member.lastName === lName &&
                    memberDetail.member.dateOfBirth === dob,
                );
              currentMemberContent[0].insuranceCarrier =
                additionalInsuranceDetails[0]?.insuranceCarrier !== ''
                  ? additionalInsuranceDetails[0]?.insuranceCarrier
                  : '';
              currentMemberContent[0].groupNumber =
                additionalInsuranceDetails[0]?.groupNumber !== ''
                  ? additionalInsuranceDetails[0]?.groupNumber
                  : '';
              currentMemberContent[0].effectiveDate =
                additionalInsuranceDetails[0]?.effectiveDate !== ''
                  ? additionalInsuranceDetails[0]?.effectiveDate
                  : '';
              currentMemberContent[0].cancelDate =
                additionalInsuranceDetails[0]?.cancelDate !== ''
                  ? additionalInsuranceDetails[0]?.cancelDate
                  : '';
              currentMemberContent[0].policyNumber =
                additionalInsuranceDetails[0]?.policyNumber !== ''
                  ? additionalInsuranceDetails[0]?.policyNumber
                  : '';
              currentMemberContent[0].relationshipToSubscriber =
                additionalInsuranceDetails[0]?.relationshipToSubscriber !== ''
                  ? additionalInsuranceDetails[0]?.relationshipToSubscriber
                  : '';
              currentMemberContent[0].employmentStatus =
                additionalInsuranceDetails[0]?.employmentStatus !== ''
                  ? additionalInsuranceDetails[0]?.employmentStatus
                  : '';
              currentMemberContent[0].retirementDate =
                additionalInsuranceDetails[0]?.retirementDate !== ''
                  ? additionalInsuranceDetails[0]?.retirementDate
                  : '';
              currentMemberContent[0].hasAdditionalInsurance = 'Y';
              currentMemberContent[0].subscriber.member.firstName =
                additionalInsuranceDetails[0]?.subscriber.member.firstName !==
                ''
                  ? additionalInsuranceDetails[0]?.subscriber.member.firstName
                  : '';
              currentMemberContent[0].subscriber.member.lastName =
                additionalInsuranceDetails[0]?.subscriber.member.lastName !== ''
                  ? additionalInsuranceDetails[0]?.subscriber.member.lastName
                  : '';
              currentMemberContent[0].subscriber.member.dateOfBirth =
                additionalInsuranceDetails[0]?.subscriber.member.dateOfBirth !==
                ''
                  ? additionalInsuranceDetails[0]?.subscriber.member.dateOfBirth
                  : '';
              currentMemberContent[0].custody =
                additionalInsuranceDetails[0]?.custody !== ''
                  ? additionalInsuranceDetails[0]?.custody
                  : '';
              currentMemberContent[0].parentWithPrimaryMedicalResponsibility =
                additionalInsuranceDetails[0]
                  ?.parentWithPrimaryMedicalResponsibility !== ''
                  ? additionalInsuranceDetails[0]
                      ?.parentWithPrimaryMedicalResponsibility
                  : '';
              currentMemberContent[0].dependentInformationCourtOrder =
                additionalInsuranceDetails[0]
                  ?.dependentInformationCourtOrder !== ''
                  ? additionalInsuranceDetails[0]
                      ?.dependentInformationCourtOrder
                  : '';
            }
          } else {
            // setOPISINFO(initialCOB);
            currentMemberContent[0].insuranceCarrier = '';
            currentMemberContent[0].groupNumber = '';
            currentMemberContent[0].effectiveDate = '';
            currentMemberContent[0].cancelDate = '';
            currentMemberContent[0].policyNumber = '';
            currentMemberContent[0].relationshipToSubscriber = '';
            currentMemberContent[0].employmentStatus = '';
            currentMemberContent[0].retirementDate = '';
            currentMemberContent[0].hasAdditionalInsurance = 'Y';
            currentMemberContent[0].subscriber.member.firstName = '';
            currentMemberContent[0].subscriber.member.lastName = '';
            currentMemberContent[0].subscriber.member.dateOfBirth = '';
            currentMemberContent[0].custody = '';
            currentMemberContent[0].parentWithPrimaryMedicalResponsibility = '';
            currentMemberContent[0].dependentInformationCourtOrder = '';
          }
        },
      );
    }
    memberCopy.memberInfo = event.target.value;
    memberCopyOf.push(memberCopy);

    if (retainselectedDetail) {
      itemsList = JSON.parse(retainselectedDetail);
      const getItem = itemsList.filter((item: any) => item.index === index);
      if (getItem.length > 0) {
        getItem[0].memberInfo = event.target.value;
      } else {
        itemsList.push(memberCopy);
      }
      localStorage.setItem('memberCopyOf', JSON.stringify(itemsList));
    } else {
      localStorage.setItem('memberCopyOf', JSON.stringify(memberCopyOf));
    }

    form.selectedDependentInfo = event.target.value;

    setForm({ selectedDependentInfo: event.target.value });
    setErrors({
      ...errors,
      [id]: value,
    });
    errorHandling(true);
  };

  return (
    <COBLayout
      title={
        OPISResponseInfo?.member?.firstName ===
          dependantList?.demographics?.firstName &&
        OPISResponseInfo.member?.dateOfBirth ===
          dependantList?.demographics?.dateOfBirth
          ? COBQuestioner.COB.INFORMATION.YOUROTHERINSURANCE
          : `${`${OPISResponseInfo.member.firstName} ${OPISResponseInfo.member.lastName}${COBQuestioner.COB.INFORMATION.DEPENDENTOTHERINSURANCE}`}`
      }
      dataTestId="same-insurance"
      questionTitle={`${OPISResponseInfo.member?.firstName} ${COBQuestioner.COB.QUESTIONS.CONTROLS.SAMEINSURANCEAS.HASTHESAMETITLE}`}
      disclaimer={
        COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.SELECTONE
      }
    >
      {isLoading && <LoadingIndicator />}
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$one $none $none $none',
          } as GDSStyleObject
        }
      >
        <FormField
          id="nameInput6"
          label=""
          aria-label="Select one(Optional)"
          hideLabel={{ '@initial': false, '@tablet': true }}
        >
          <Select
            options={relationsList}
            id="selectedDependentInfo"
            aria-label="selected Dependent Info"
            css={{}}
            onChange={copyMemberInfo}
            value={
              ParsedJson[0]?.memberInfo
                ? ParsedJson[0]?.memberInfo
                : form?.selectedDependentInfo
            }
            data-testid="relationValue"
          />
        </FormField>
      </Box>
    </COBLayout>
  );
}
